/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rule-list[_ngcontent-%COMP%]{display:flex;gap:4px}.rule-item[_ngcontent-%COMP%]{color:var(--error-color);display:flex;align-items:center;font-size:var(--font-size-large-15)}.rule-item.fixed-rule[_ngcontent-%COMP%]{color:var(--correct-color)}.glyphicons[_ngcontent-%COMP%]{cursor:unset;font-size:8px}.glyphicons[_ngcontent-%COMP%]::before{padding:0 2px 6px}\n/*# sourceMappingURL=rc-qa-codes.component.css.map*/"];
export { styles as styles };
